import { SendingResponse, Response } from '../../types/surveyData';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QueType } from '@services/survey/surveySlice';

export enum PreviewType {
  Participate = 'Participate',
  Build = 'Build',
  Revise = 'Revise',
  Result = 'Result',
}

export class ResponseData {
  response: Response = {} as Response;
  type: QueType | null = null;
  questionId: string = '';
}

export class MulitpleResponseData {
  responses: SendingResponse[] = [];
  questionId: string = '';
}

export interface ResponsesState {
  responseId: string | null;
  responses: SendingResponse[];
  surveyParticipantId: string | null;
}

const initialState: ResponsesState = {
  responseId: null,
  responses: [] as SendingResponse[],
  surveyParticipantId: null,
};

export const responseSlice = createSlice({
  name: 'response',
  initialState,
  reducers: {
    setResponseId(state, action: PayloadAction<any>) {
      state.responseId = action.payload;
    },
    setParticipantId(state, action: PayloadAction<any>) {
      state.surveyParticipantId = action.payload;
    },
    setResponse(state, action: PayloadAction<ResponseData>) {
      const response = action.payload?.response;
      if (response && action.payload?.type) {
        const que = state.responses.filter((item) => item.questionId === action.payload.questionId);
        let arr =
          que && que.length !== 0
            ? state.responses.filter((item) => item.questionId !== action.payload.questionId)
            : state.responses;
        let res = new SendingResponse();
        res.responseText = response.responseText ? response.responseText : null;
        res.responseValue = response.responseValue ? response.responseValue : null;
        res.questionType = action.payload.type;
        res.questionId = action.payload.questionId;
        arr.push(res);
        state.responses = arr;
      }
    },
    setMultipleResponses(state, action: PayloadAction<MulitpleResponseData>) {
      let responses = state.responses?.filter((item) => item.questionId !== action.payload.questionId);
      action.payload?.responses?.forEach((item) => {
        responses.push(item);
      });
      state.responses = responses;
    },
    setEtcResponse(state, action: PayloadAction<SendingResponse>) {
      const opt = state.responses.filter((item) => item.optionId === action.payload.optionId)[0];
      let exceptOpt = state.responses.filter((item) => item.optionId !== action.payload.optionId);
      if (opt) {
        let newOpt = { ...opt };
        newOpt.optionEtcText = action.payload.optionEtcText;
        exceptOpt.push(newOpt);
        state.responses = exceptOpt;
      }
    },
  },
});

export const { setResponse, setResponseId, setParticipantId, setMultipleResponses, setEtcResponse } =
  responseSlice.actions;
export default responseSlice;
